import { Layout } from "@overmap-ai/blocks"
import { Outlet } from "@tanstack/react-router"
import { type CSSProperties, memo, useState } from "react"

import { GeometryPickerProvider } from "../contexts/GeometryPickerContext/provider"
import { useViewportSize } from "../contexts/hooks"
import { ImageOverlayPickerProvider } from "../contexts/ImageOverlayPickerContext/provider"
import { LocationPickerProvider } from "../contexts/LocationPickerContext/provider"
import { PolygonPickerProvider } from "../contexts/PolygonPickerContext/Provider"
import { Layer, Source } from "../mapbox/components"
import { Map } from "../mapbox/components/Map"
import { EMPTY_FEATURE_COLLECTION, EMPTY_SOURCE_ID } from "../mapbox/constants"
import { MapSlotLayerId } from "../mapbox/enums"
import { useAppSelector } from "../store"
import { selectMapStyle } from "../store/selectors"

const style = { inset: 0, position: "fixed", zIndex: 400 } satisfies CSSProperties

export const MapLayout = memo(() => {
	const [hideLayout, setHideLayout] = useState(false)
	const { lg } = useViewportSize()
	const mapStyle = useAppSelector(selectMapStyle)

	return (
		<Map style={style} mapStyle={mapStyle}>
			<Source id={EMPTY_SOURCE_ID} key={EMPTY_SOURCE_ID} type="geojson" data={EMPTY_FEATURE_COLLECTION}>
				<Layer type="slot" id={MapSlotLayerId.DRAW} />
				<Layer type="slot" id={MapSlotLayerId.SELECTION} beforeId={MapSlotLayerId.DRAW} />
				<Layer type="slot" id={MapSlotLayerId.ASSETS} beforeId={MapSlotLayerId.SELECTION} />
				<Layer type="slot" id={MapSlotLayerId.PROJECT_BOUNDS} beforeId={MapSlotLayerId.ASSETS} />
				<Layer type="slot" id={MapSlotLayerId.PROJECT_FILES} beforeId={MapSlotLayerId.PROJECT_BOUNDS} />
			</Source>

			<Layout.Root small={!lg} hideLayout={hideLayout}>
				<GeometryPickerProvider onOpenChange={setHideLayout}>
					<PolygonPickerProvider onOpenChange={setHideLayout}>
						<LocationPickerProvider onOpenChange={setHideLayout}>
							<ImageOverlayPickerProvider onOpenChange={setHideLayout}>
								<Outlet />
							</ImageOverlayPickerProvider>
						</LocationPickerProvider>
					</PolygonPickerProvider>
				</GeometryPickerProvider>
			</Layout.Root>
		</Map>
	)
})
MapLayout.displayName = "MapLayout"
